import { Trash2, Pencil, GripVertical } from "lucide-react";

export const ExtraListItem = ({ extra, onDragStart, onDragOver, onDrop, onEdit, onDelete }) => (
  <div
    draggable
    onDragStart={onDragStart}
    onDragOver={onDragOver}
    onDrop={onDrop}
    className="flex items-center justify-between border rounded px-4 py-3 cursor-move"
    data-testid={`admin-extra-item-${extra.id}`}
  >
    <div className="flex items-center gap-2">
      <GripVertical size={16} className="text-muted-foreground shrink-0" />
      <p className="text-sm font-medium">{extra.label} — ${Number(extra.price).toLocaleString("es-MX")}</p>
    </div>
    <div className="flex gap-2 shrink-0">
      <button data-testid={`admin-extra-edit-${extra.id}`} onClick={onEdit}><Pencil size={16} /></button>
      <button data-testid={`admin-extra-delete-${extra.id}`} onClick={onDelete}><Trash2 size={16} /></button>
    </div>
  </div>
);
